"use strict";

module.exports = {
    "search2": {
        "search-button-text": "Знайти",
        "search-input-label": "Запит",
        "search-service-label": "Пошук на сервісі",
        "search-web-label": "Пошук в інтернеті"
    }
};